import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['selectAll', 'row', 'exportBtn', 'errorMsg']

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.rowTargets.forEach(cb => { cb.checked = checked })
    this.syncExportBtn()
  }

  syncSelectAll() {
    const total = this.rowTargets.length
    const checkedCount = this.rowTargets.filter(cb => cb.checked).length
    this.selectAllTarget.indeterminate = checkedCount > 0 && checkedCount < total
    this.selectAllTarget.checked = total > 0 && checkedCount === total
    this.syncExportBtn()
  }

  syncExportBtn() {
    const anyChecked = this.rowTargets.some(cb => cb.checked)
    this.exportBtnTargets.forEach(btn => {
      btn.classList.toggle('opacity-50', !anyChecked)
      btn.classList.toggle('cursor-not-allowed', !anyChecked)
    })
    if (anyChecked) this.hideError()
  }

  rowTargetDisconnected() {
    this.syncExportBtn()
  }

  prepareAndSubmit(event) {
    const checkedRows = this.rowTargets.filter(cb => cb.checked)

    if (checkedRows.length === 0) {
      event.preventDefault()
      this.showError()
      return
    }

    this.hideError()
    const form = event.target.closest('form')
    form.querySelectorAll('input[name="encounter_ids[]"]').forEach(f => f.remove())
    checkedRows.forEach(cb => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'encounter_ids[]'
      input.value = cb.value
      form.appendChild(input)
    })
  }

  showError() {
    this.errorMsgTarget.classList.remove('hidden')
  }

  hideError() {
    this.errorMsgTarget.classList.add('hidden')
  }
}
